import { render } from "./kalio-investor-list.vue?vue&type=template&id=25072327"
import script from "./kalio-investor-list.vue?vue&type=script&lang=js"
export * from "./kalio-investor-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__